module.exports = __webpack_public_path__ + "img/checkbox.52710f50.svg";